const SettingsPage = () => {
  return <>Settings Page</>;
};

export default SettingsPage;
